module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_8023.e32ecd20.png";